import Extension from "../base/extension";

/**
 * Support extension for the QuickView custom element
 *
 * @see {@link file://./../elements/quick-view.js}
 * @see {@link file://./../../sections/quick-view.liquid}
 * @see {@link file://./../../../snippets/modal-quick-view.liquid}
 */
class QuickView extends Extension {

  static #attached = false;

  init() {
    if (QuickView.#attached) return;
    document.body.addEventListener("click", this.#onClick);
    QuickView.#attached = true;

    document.addEventListener("cart:refreshed", () => {
      this.close();
    });
  }

  #onClick = e => {
    const btn = e.target.closest("[data-qv-initialise]");
    if (!btn) return;

    e.preventDefault();

    const handle = btn.dataset.qvInitialise?.trim();
    if (!handle) return;

    this.open(handle, btn);
  };

  /**
   * Opening is now just showModal(). The old implementation had to dismiss any
   * other open modal first and re-show it afterwards, because Bootstrap modals
   * cannot coexist; the top layer stacks them natively, so an already-open
   * overlay simply sits underneath. Focus return to the trigger is handled by
   * extensions/dialogs.js when the dialog is opened through it.
   */
  open(handle, trigger = null) {
    const el = document.querySelector("quick-view");
    if (!el) {
      console.warn(this.logPrefix, "QuickView element not found. Does the section exist in 'Overlay group'?");
      return;
    }

    el.setAttribute("handle", handle);

    const dialog = document.getElementById("quickViewModal");
    if (!dialog) return;

    // Prefer the Dialogs extension so focus return to the trigger is wired;
    // fall back to the raw call if it is somehow unavailable. Not `??`: open()
    // returns undefined, so that would always run the fallback as well.
    const dialogs = window.Stencil?.Extensions?.Dialogs;
    if (dialogs) dialogs.open(dialog, trigger);
    else if (!dialog.open) dialog.showModal();
  }

  close() {
    document.getElementById("quickViewModal")?.close();
  }
}

export default QuickView;
